import React from 'react';

export function ArrowIcon(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
		<path d="M6.5 0L5.4425 1.0575L9.6275 5.25H0.5V6.75H9.6275L5.435 10.935L6.5 12L12.5 6L6.5 0Z" fill="white"/>
	  </svg>);
}